import setupSelects from '@/components/forms/select';
import SmoothScroll from 'smooth-scroll';

/* eslint-disable no-new */
export class Form {
    constructor(formElement) {
        setupSelects(formElement);
        this.formElement = formElement;
        this.formWrapper = formElement.closest('.Form');
        this.smoothScroll = new SmoothScroll();
        this.addEventListeners();
    }

    addEventListeners() {
        // Handle DOM changes after successful submission
        this.formElement.addEventListener(
            'onAfterFormieSubmit',
            this.handleSuccessfulSubmit.bind(this)
        );
    }

    trackSubmission() {
        console.log('tracked');
        const enquiryType = this.formElement.querySelector('select[name="fields[iNeedHelpWith]"]');

        window.dataLayer.push({
            event: 'Global Form Submission'
        });
        window.dataLayer.push({
            event: 'Form Submission',
            form: JSON.parse(this.formElement.dataset.fuiForm).formHandle,
            enquiryType: enquiryType && enquiryType.value
        });
    }

    handleSuccessfulSubmit() {
        this.formWrapper.classList.add('success');
        this.formWrapper.querySelector('.Form__show-on-submit').classList.add('toggled');
        this.formWrapper.querySelector('.Form__hide-on-submit').classList.add('toggled');
        this.formWrapper.querySelector('.Form__show-on-submit h2').focus();
        this.trackSubmission();
        setTimeout(() => {
            this.smoothScroll.animateScroll(this.formWrapper, 0, { offset: 150 });
        }, 500);
    }
}

export default (() => {
    const forms = Array.from(document.querySelectorAll('form.fui-form'));

    forms.forEach((formElement) => {
        new Form(formElement);
    });
})();
